/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Modal_Type_RequiredInputs */

const es_feedback_modal_type_required = /** @type {(inputs: Feedback_Modal_Type_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Debes seleccionar un tipo.`)
};

const en_feedback_modal_type_required = /** @type {(inputs: Feedback_Modal_Type_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You must select a type.`)
};

/**
* | output |
* | --- |
* | "You must select a type." |
*
* @param {Feedback_Modal_Type_RequiredInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const feedback_modal_type_required = /** @type {((inputs?: Feedback_Modal_Type_RequiredInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Modal_Type_RequiredInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_feedback_modal_type_required(inputs)
	return en_feedback_modal_type_required(inputs)
});
export { feedback_modal_type_required as "feedback.modal.type_required" }